import SettingsPage from './SettingsPage';

export default SettingsPage;

export type TTabname = 'permissions' | 'tools' | 'audit-logs' | 'payment-providers' | 'payment-packages' | 'payment-method-requests';
